import { format } from 'date-fns';

const extractTimeStringFromDate = (date: Date, useAmPm = false): string => {
  if (!date) {
    return '00:00';
  }

  return format(date, useAmPm ? 'h:mm a' : 'HH:mm');
};

export default extractTimeStringFromDate;
